const DebounceTimer = {
	activeTimers: {},

	/**
	 * Debounce a callback by key.
	 * Optionally, pass a Vue 2 component instance to automatically clear the timer when the component is destroyed.
	 *
	 * @param {string} key - Unique key for this timer
	 * @param {Function} callback - Function to call after debounce
	 * @param {number} delay - Debounce delay in ms (default 100)
	 * @param {Vue} vueInstance - Optional Vue 2 component instance
	 */
	debounce(key, callback, delay = 100, vueInstance = null) {
		// If a Vue instance is provided, namespace the key with the component's _uid
		const timerKey = this._buildTimerKey(key, vueInstance);

		// Clear the existing timer for this key
		this._clearInternal(timerKey);

		// Set a new timer
		this.activeTimers[timerKey] = setTimeout(() => {
			this._clearInternal(timerKey);
			callback();
		}, delay);

		// Auto-cleanup for Vue component
		if (vueInstance && vueInstance.$options) {
			vueInstance.$options.beforeDestroy.push(() => {
				this._clearInternal(timerKey);
			});
		}
	},
	/**
	 * Clear an active "debounce" timer by key.
	 * Optionally, pass a Vue 2 component instance when debounce was used with one.
	 *
	 * @param {string} key - Unique key for this timer
	 * @param {Vue} vueInstance - Optional Vue 2 component instance that was used with "debounce"
	 */
	clearTimer(key, vueInstance = null) {
		this._clearInternal(this._buildTimerKey(key, vueInstance));
	},
	_clearInternal(timerKey) {
		if (this.activeTimers[timerKey]) {
			clearTimeout(this.activeTimers[timerKey]);
			delete this.activeTimers[timerKey];
		}
	},
	_buildTimerKey(key, vueInstance) {
		return vueInstance ? `${key}_${vueInstance._uid}` : key;
	}
};

export {
	DebounceTimer
};